import { render, staticRenderFns } from "./TableRestrictionSidebar.vue?vue&type=template&id=035ecdd8&scoped=true&"
import script from "./TableRestrictionSidebar.vue?vue&type=script&lang=js&"
export * from "./TableRestrictionSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035ecdd8",
  null
  
)

export default component.exports